export default {
	changedRecord: null,
	newRecord: null,
	loading: false,
	error: ''
};



// WEBPACK FOOTER //
// ./src/reducers/record/record-initialState.js